/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    MoyaComponents.register('site.tabBoxes', function (el) {
        el.querySelectorAll('.cards__container__tabs li[data-codename]').forEach(function (button) {
            button.addEventListener('click', function () {
                //Update button active class
                el.querySelectorAll('.cards__container__tabs li[data-codename]').forEach(function (btn) {
                    btn.classList.remove('active');
                });
                button.classList.add('active');
                el.querySelectorAll('.cards__container__tab').forEach(function (container) {
                    if (container.getAttribute('data-filter-codename') === button.getAttribute('data-codename')) {
                        container.classList.add('active');
                    }
                    else {
                        container.classList.remove('active');
                    }
                });
            });
        });
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
